<template>
  <div class="relative py-2 bg-white flex flex-row" :class="wrapperClasses">
    <div
      class="border-mid-gray border rounded-lg w-full sm:w-full h-12"
      :class="[size === 'sm' ? 'h-9' : 'h-12']"
    >
      <span
        :class="[size === 'sm' ? 'h-9' : 'h-12']"
        class="absolute inset-y-0 left-0 flex items-center pl-4 pt-3.5 flex-row justify-center"
      >
        <SearchIcon />
      </span>

      <input
        role="search"
        type="text"
        :class="[size === 'sm' ? 'h-8 !pb-1' : 'h-10', inputClasses]"
        class="!pt-1"
        :placeholder="placeholder"
        :value="modelValue"
        @input="
          $emit('update:modelValue', ($event.target as HTMLInputElement).value)
        "
        @keyup="throttledEmitEnter"
      />
    </div>
    <button
      v-if="modelValue"
      class="flex items-center bg-bkk-25 rounded-full ml-2 transition-colors duration-200"
      :class="[size === 'sm' ? 'p-2 px-2.5' : 'p-3']"
      @click="emitClose"
    >
      <CloseIcon :class="[size === 'sm' ? 'h-4 w-4' : '']" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import { useThrottleFn } from "@vueuse/core";
import CloseIcon from "../icon/CloseIcon.vue";
import SearchIcon from "../icon/SearchIcon.vue";

const props = defineProps<{
  modelValue: string;
  placeholder?: string;
  inputClasses?: string;
  wrapperClasses?: string;
  searchIconAltText?: string;
  size?: "sm" | "lg";
}>();

const emit = defineEmits<{
  (e: "onKeyUpEnter"): void;
  (e: "onCloseSearch"): void;
  (e: "update:modelValue", value: string): void;
}>();

const emitEnter = () => {
  emit("onKeyUpEnter");
};

const throttledEmitEnter = useThrottleFn(emitEnter, 300);

const emitClose = () => {
  emit("onCloseSearch");
};
</script>
